import { render, staticRenderFns } from "./realtime.vue?vue&type=template&id=2948d46c&"
import script from "./realtime.vue?vue&type=script&lang=js&"
export * from "./realtime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports